export const DB_NAME = "oceanlogix_v2";
export const DB_VERSION = 3;

export const TABLES = Object.freeze({
  ORGANIZATIONS: "organizations",
  VESSELS: "vessels",
  VESSEL_PARTICULARS: "vesselParticulars",
  TANKS: "tanks",
  VOYAGES: "voyages",
  TRIPS: "trips",
  TRIP_CARGO: "tripCargo",
  AUDIT_ENTRIES: "auditEntries",
  SYNC_OPERATIONS: "syncOperations",
  CREDENTIAL_PACKAGES: "credentialPackages",
  LOCAL_SESSIONS: "localSessions",
  VESSEL_INSTALLATIONS: "vesselInstallations",
  GENERATED_DOCUMENTS: "generatedDocuments",
});

export const STORE_DEFINITIONS = {
  [TABLES.ORGANIZATIONS]: "&id, slug, updatedAt",
  [TABLES.VESSELS]: "&id, organizationId, name, updatedAt, [organizationId+name]",
  [TABLES.VESSEL_PARTICULARS]: "&vesselId, updatedAt",
  [TABLES.TANKS]: "&id, vesselId, tankType, active, updatedAt, [vesselId+tankType]",
  [TABLES.VOYAGES]:
    "&id, organizationId, vesselId, voyageNumber, status, currentTripId, updatedAt, revision, [vesselId+status]",
  [TABLES.TRIPS]:
    "&id, voyageId, sequence, operationType, status, updatedAt, revision, [voyageId+sequence]",
  [TABLES.TRIP_CARGO]:
    "&id, tripId, productName, updatedAt, revision, [tripId+productName]",
  [TABLES.AUDIT_ENTRIES]:
    "&id, entityType, entityId, occurredAt, operation, [entityType+entityId]",
  [TABLES.SYNC_OPERATIONS]:
    "&id, status, entityType, entityId, organizationId, vesselId, voyageId, tripId, updatedAt, [entityType+entityId], [organizationId+vesselId], [vesselId+status]",
  [TABLES.CREDENTIAL_PACKAGES]:
    "&id, vesselId, version, isActive, activatedAt, syncedAt, [vesselId+version], [vesselId+isActive]",
  [TABLES.LOCAL_SESSIONS]:
    "&id, userId, vesselId, status, authenticatedAt, lastActivityAt, [vesselId+status], [userId+status]",
  [TABLES.VESSEL_INSTALLATIONS]:
    "&id, vesselId, tenant, status, updatedAt, [vesselId+status]",
  [TABLES.GENERATED_DOCUMENTS]:
    "&id, organizationId, vesselId, voyageId, tripId, cargoId, templateId, deliveryStatus, generatedAt, [vesselId+generatedAt], [voyageId+generatedAt]",
};
